import { supabase } from '@/integrations/supabase/client';
import { getOwnerToken } from './blogOwner';

export async function getNewsBookmarkState(articleId: string) {
  const token = getOwnerToken();
  const { data: { user } } = await supabase.auth.getUser();
  const { data, count } = await supabase
    .from('news_bookmarks')
    .select('id, owner_token, user_id', { count: 'exact' })
    .eq('article_id', articleId);
  const list = data || [];
  const mine = list.some((r: any) => r.owner_token === token || (user && r.user_id === user.id));
  return { count: count || 0, bookmarked: mine };
}

export async function toggleNewsBookmark(articleId: string, on: boolean) {
  const owner_token = getOwnerToken();
  const { data: { user } } = await supabase.auth.getUser();
  if (on) {
    const { error } = await supabase
      .from('news_bookmarks')
      .insert({ article_id: articleId, owner_token, user_id: user?.id ?? null });
    if (error && !`${error.message}`.includes('duplicate')) throw error;
  } else {
    let q = supabase.from('news_bookmarks').delete().eq('article_id', articleId);
    if (user) q = q.or(`owner_token.eq.${owner_token},user_id.eq.${user.id}`);
    else q = q.eq('owner_token', owner_token);
    const { error } = await q;
    if (error) throw error;
  }
}

export async function listMyNewsBookmarks() {
  const token = getOwnerToken();
  const { data: { user } } = await supabase.auth.getUser();
  let q = supabase.from('news_bookmarks').select('article_id, created_at');
  q = user
    ? q.or(`owner_token.eq.${token},user_id.eq.${user.id}`)
    : q.eq('owner_token', token);
  const { data } = await q;
  return data || [];
}
